import React from "react";
import "./Spinner.css"; // We'll define styles here

type SpinnerProps = {
    label?: string;
};

export const Spinner: React.FC<SpinnerProps> = ({ label }) => {
    return (
        <div className="spinner-container">
            <div className="spinner" />
            {label && <div className="spinner-label">{label}</div>}
        </div>
    );
};
